var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM10.1002 6C10.5418 6 10.8999 6.35803 10.8999 6.79968C10.8999 7.24134 10.5418 7.59937 10.1002 7.59937C9.65852 7.59937 9.30049 7.24134 9.30049 6.79968C9.30049 6.35803 9.65852 6 10.1002 6ZM9.29968 8.66484C8.85803 8.66484 8.5 9.02287 8.5 9.46452C8.5 9.90617 8.85803 10.2642 9.29968 10.2642L9.30078 13.7009C9.30107 14.1423 9.65898 14.5 10.1004 14.5C10.542 14.5 10.9 14.142 10.9 13.7004L10.8991 9.46452C10.8991 9.02287 10.541 8.66484 10.0994 8.66484H9.29968Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "fc80ac516e54aee5de623fee514cce27.svg";
export { ForwardRef as ReactComponent };